import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { AppDispatch } from "../../../../app/store";
import { loginCasSso, setPhoneNumber } from "../auth/slice";
import notificationHandler from "../../../atoms/Notification";

const CasCallback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [searchParams] = useSearchParams();
    const ticket = searchParams.get("ticket") || "";
    const [loading, setLoading] = useState(true);
    const hasProcessed = useRef(false);

    const antIcon = (
        <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
    );

    useEffect(() => {
        if (!ticket) {
            notificationHandler("error", "Không tìm thấy ticket từ SSO");
            navigate("/login");
            return;
        }

        if (hasProcessed.current) return;
        hasProcessed.current = true;

        dispatch(loginCasSso(ticket))
            .unwrap()
            .then((res: any) => {
                console.log('res', res)
                if (res?.token) {
                    notificationHandler("success", "Đăng nhập SSO thành công!");
                    if (res?.phone) {
                        dispatch(setPhoneNumber(res.phone));
                    }
                    navigate("/order-meals");
                } else {
                    notificationHandler(
                        "error",
                        res?.msg_content || "Đăng nhập SSO không thành công"
                    );
                    navigate("/login");
                }
            })
            .catch((error: any) => {
                const message =
                    error?.response?.data?.data?.msg_content ||
                    error?.message ||
                    "Xác thực SSO thất bại. Vui lòng thử lại.";
                notificationHandler("error", message);
                navigate("/login");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [ticket]);

    return (
        <>
            <div className="flex h-screen items-center justify-center">
                <Spin indicator={antIcon} spinning={loading} />
            </div>
        </>
    );
};

export default CasCallback;
